import { CruisesContract as API, definitions } from '@luxuryescapes/contract-svc-cruise';

import cruisesAPI from './CruisesApiService';

const resource = 'luxplus-pricing-configs';

export type LuxPlusPricingFilter = definitions['LUXPLUS_PRICING_FILTER'];
export type LuxPlusPricingMode = definitions['LUXPLUS_PRICING_MODE'];
export type LuxPlusPricingConfig = definitions['LUXPLUS_PRICING_CONFIG'];
export type CreateLuxPlusPricingConfigBody = definitions['CREATE_LUXPLUS_PRICING_CONFIG_BODY'];

const list = async (vendorId: string): Promise<API.Response<Array<LuxPlusPricingConfig>>> => {
  return await cruisesAPI.http.get({ resource, queryString: JSON.stringify({ vendorId }) });
};

const create = async (body: CreateLuxPlusPricingConfigBody): Promise<LuxPlusPricingConfig> => {
  const response = await cruisesAPI.http.post<API.Response<LuxPlusPricingConfig>>({ resource, body });
  return response.result;
};

const updateEnabled = async (id: string, enabled: boolean): Promise<LuxPlusPricingConfig> => {
  const response = await cruisesAPI.http.put<LuxPlusPricingConfig>({
    resource: `${resource}/${id}`,
    body: { enabled },
  });
  return response.result;
};

const deleteById = async (id: string): Promise<LuxPlusPricingConfig> => {
  const response = await cruisesAPI.http.delete<LuxPlusPricingConfig>({ resource: `${resource}/${id}` });
  return response.result;
};

export default { list, create, updateEnabled, deleteById };
